
import { db } from "../firestore";
import { userData } from "../stores/userStore";

export const signIn = async function() {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInAnonymously()
        .then(data => {
          console.log("Start createUserDoc on Client");

          console.log(data);

          db.collection("sneak-peek-users")
            .doc(data.user.uid)
            .set({
              lastStep: 0
            })
            .then(result => {
              console.log("User doc created");
              userData.setData({user: data.user})
              resolve({userId: data.user.uid})
            })
            .catch(err => {
              console.log(err);
              reject(err)
            });
        })
        .catch(error => {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log(errorCode);
          console.log(errorMessage);
          reject(error)

        });
    });
  }